import {
  AX_TIER_DEFAULT_COLOR_PRESET,
  defaultBranding,
  getColorPresetPrimary,
  type BrandingConfig,
} from '@axsolutionsdev/core-fe';

export const defaultMesBranding: BrandingConfig = {
  ...defaultBranding,
  productName: 'AX MES',
  title: 'AX MES',
  colors: {
    primary: getColorPresetPrimary(AX_TIER_DEFAULT_COLOR_PRESET.mes),
    secondary: '#1E3A8A',
    accent: '#22D3EE',
  },
  logo: {
    ...defaultBranding.logo,
    favicon: '/favicon.svg',
    loginBackground: '/branding/mes-login-bg.png',
    // 제품 아이콘(파비콘)을 원형 칩으로 자르지 않고 앱 아이콘 그대로 크게 표시
    loginLogoVariant: 'rect',
  },
};

export function mergeMesBranding(override?: Partial<BrandingConfig>): BrandingConfig {
  if (!override) {
    return defaultMesBranding;
  }
  return {
    ...defaultMesBranding,
    ...override,
    logo: {
      ...defaultMesBranding.logo,
      ...override.logo,
    },
  };
}
